import Joi from 'joi';
import PropTypes from 'prop-types';

import Form from '../../common/form';
import toastService from '../../../services/toastService';

class StructuralOverviewForm extends Form {
	state = {
		data: {
			structuralOverview: '',
		},
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		structuralOverview: Joi.string().min(5).required().label('Structural Overview'),
	};

	static propTypes = {
		initialOverview: PropTypes.string,
		onProceed: PropTypes.func,
	};

	doSubmit = (): void => {
		this.props.onProceed(this.state.data.structuralOverview);

		toastService.success('Structural Overview updated successfully!.');
	};

	componentDidMount() {
		this.setState({ data: { structuralOverview: this.props.initialOverview ?? '' } });
	}

	componentDidUpdate(previousProps: { initialOverview: string; }) {
		if (previousProps.initialOverview !== this.props.initialOverview) {
			this.setState({
				data: { structuralOverview: this.props.initialOverview },
			});
		}
	}

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				{this.renderTextEditor({
					name: 'structuralOverview',
					label: 'Structural Overview',
					placeholder: 'Describe the overall structural configuration e.g trestle, pipe racks, decking etc.',
				})}

				<div className="divider my-4"></div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Save Structural Overview')}
				</div>
			</form>
		);
	}
}

export default StructuralOverviewForm;
